
import {defineComponent} from 'vue';
import {CardHeaders} from '../types';
import {decoratorMixin} from './decorator-mixin';
import TableBody from '@ohrm/oxd/core/components/CardTable/Table/TableBody.vue';
import TableRow from '@ohrm/oxd/core/components/CardTable/Table/TableRow.vue';
import DefaultCellContainer from '@ohrm/oxd/core/components/CardTable/Cell/DefaultCellContainer.vue';
import emitter from '../../../../utils/emitter';

export default defineComponent({
  name: 'oxd-table-default-card-mobile',

  mixins: [decoratorMixin],

  components: {
    'oxd-card-tbody': TableBody,
    'oxd-card-tr': TableRow,
    'oxd-card-cell': DefaultCellContainer,
  },

  computed: {
    classes(): object {
      return {
        'oxd-table-card': true,
        '--mobile': true,
      };
    },
    defaultSlot(): Array<CardHeaders> {
      return this.tableProps.headers.filter(header => {
        return header?.slot === undefined || header?.slot === 'default';
      });
    },
    titleSlot(): Array<CardHeaders> {
      return this.tableProps.headers.filter(header => {
        return header?.slot === 'title';
      });
    },
    actionSlot(): Array<CardHeaders> {
      return this.tableProps.headers.filter(header => {
        return header?.slot === 'action';
      });
    },
    footerSlot(): Array<CardHeaders> {
      return this.tableProps.headers.filter(header => {
        return header?.slot === 'footer';
      });
    },
    leftSlot(): Array<CardHeaders> {
      return this.tableProps.headers.filter(header => {
        return header?.slot === 'left';
      });
    },
    rightSlot(): Array<CardHeaders> {
      return this.tableProps.headers.filter(header => {
        return header?.slot === 'right';
      });
    },
  },

  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onClick(item: any) {
      return (e: Event) => {
        emitter.emit(`${this.tableProps.tableId}-datatable:clickRow`, {
          item,
          native: e,
        });
      };
    },
  },
});
